import { FC, Fragment, ReactNode } from 'react';
import { Modal } from 'react-bootstrap';
import GenericButton from '../../components/form/GenericButton';
import Loader from './loader/loader';

interface CreateEngagementProps {deleteFn:any, visible:boolean, toggleVisibility: any, objectLabel: string, title: string, isLoading:boolean, warning?: ReactNode }
const ModalDelete: FC<CreateEngagementProps> = ({deleteFn, visible, toggleVisibility, objectLabel, title, isLoading, warning}) => {

    return (
        <Fragment>
            {           
                visible &&
                <Modal id="m1" style={{background: "rgba(0,0,0,.5)"}}  className="fade" aria-hidden="true" aria-labelledby="contained-modal-title-vcenter" centered show={visible} onHide={()=>{toggleVisibility(!visible)}}>
                    <Modal.Header closeButton>
                        <Modal.Title id="exampleModalToggleLabel">
                            <>
                                <svg className="custom-alert-icon svg-danger pr-1" xmlns="http://www.w3.org/2000/svg" height="2.5rem" viewBox="0 0 24 24" width="2.5rem" fill="#000000">
                                    <path d="M0 0h24v24H0z" fill="none" /><path d="M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM12 17.3c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3.72 0 1.3.58 1.3 1.3 0 .72-.58 1.3-1.3 1.3zm1-4.3h-2V7h2v6z" />
                                </svg>
                                <span className="ps-1">Delete {title}</span>
                            </>
                            </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {isLoading && <Loader/>}
                        <div className="d-flex flex-column align-items-center ">
                            <p className='text-center'>
                            <span className="d-block">{`You're going to delete the ${title}`}</span>
                            <span className='fw-bold'>{`${objectLabel} `}</span><span>Are you sure?</span>
                            </p>
                            {warning}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <GenericButton className="btn-danger" onClick={deleteFn} label="Yes, Delete!" type="submit"/>
                        <GenericButton onClick={()=>{toggleVisibility(!visible);}} isPrimary={false} label="No, Keep it" type="button" className="ms-2"/>
                    </Modal.Footer>
                </Modal>
            }
        </Fragment>
    );
};

export default (ModalDelete);